import {vignetService} from '../services/vignets.services';

export const getRecentVignets = ( data1 ) => dispatch => {
    let vignetList = vignetService.getAllVignets(data1);
    vignetList.then(vignetList => {
        dispatch({
            type: "RECENT_VIGNETS_SUCCESS",
            vignetList
        });
    });
}
export const getMostviewedVignets = ( data2 ) => dispatch => {

    let vignetList = vignetService.getAllVignets(data2);

    vignetList.then(vignetList => {
        dispatch({
            type: "VIEWED_VIGNETS_SUCCESS",
            vignetList
        });
    });
}
export const getGraphData = (data) => dispatch => {

    let graphData = vignetService.getDashboardGraphData(data);

    graphData.then(graphData => {
        console.log(graphData);
        dispatch({
            type: "DASHBOARD_GRAPH_SUCCESS",
            graphData
        });
    });
}
export const getShareData = ( ) => dispatch => {

    let shareData = vignetService.getDashboardShareData();

    shareData.then(shareData => {
        dispatch({
            type: "DASHBOARD_SHARE_DATA_SUCCESS",
            shareData
        });
    });
}



// WEBPACK FOOTER //
// ./src/actions/overview.js